/**
 * Device photos for the marketing landing coverflow.
 * Studio black is keyed to alpha. Captions are short ASCII-hyphen copy.
 */
export const LANDING_PRODUCT_SHOT_AUTOPLAY_MS = 6000;

export const LANDING_PRODUCT_SHOT_SLIDE_MS = 800;

export const LANDING_PRODUCT_SHOTS_SECTION_ID = 'product-shots';

export const LANDING_PRODUCT_SHOTS_HEADING_LEAD = 'Plan, fuel';

export const LANDING_PRODUCT_SHOTS_HEADING_ACCENT = 'and meals';

export const LANDING_PRODUCT_SHOTS_HEADING = `${LANDING_PRODUCT_SHOTS_HEADING_LEAD}, ${LANDING_PRODUCT_SHOTS_HEADING_ACCENT}`;

export const LANDING_PRODUCT_SHOTS = [
  {
    id: 'home',
    src: '/landing/phone-device-home.webp',
    filename: 'phone-device-home.webp',
    width: 843,
    height: 1642,
    caption: 'Your next ride briefing.',
    alt: 'Your next ride briefing.',
    kicker: 'Pre-ride',
  },
  {
    id: 'training-plan',
    src: '/landing/phone-device-training-plan.webp',
    filename: 'phone-device-training-plan.webp',
    width: 850,
    height: 1687,
    caption: 'Your training plan this week.',
    alt: 'Your training plan this week.',
    kicker: 'Plan',
  },
  {
    id: 'personal-bests',
    src: '/landing/phone-device-personal-bests.webp',
    filename: 'phone-device-personal-bests.webp',
    width: 851,
    height: 1730,
    caption: 'Your power and distance records.',
    alt: 'Your power and distance records.',
    kicker: 'Records',
  },
  {
    id: 'nutrition-plan',
    src: '/landing/phone-device-nutrition-plan.webp',
    filename: 'phone-device-nutrition-plan.webp',
    width: 863,
    height: 1737,
    caption: "Today's meals for a ride day.",
    alt: "Today's meals for a ride day.",
    kicker: 'Meals',
  },
  {
    id: 'coach',
    src: '/landing/phone-device-coach.webp',
    filename: 'phone-device-coach.webp',
    width: 865,
    height: 1722,
    caption: 'Fuel your next session with your coach.',
    alt: 'Fuel your next session with your coach.',
    kicker: 'Coach',
  },
  {
    id: 'activities',
    src: '/landing/phone-device-activities.webp',
    filename: 'phone-device-activities.webp',
    width: 862,
    height: 1764,
    caption: 'Your rides this week.',
    alt: 'Your rides this week.',
    kicker: 'Rides',
  },
  {
    id: 'bonk-lab',
    src: '/landing/phone-device-bonk-lab.webp',
    filename: 'phone-device-bonk-lab.webp',
    width: 910,
    height: 1728,
    caption: 'What-if modeling for this ride.',
    alt: 'What-if modeling for this ride.',
    kicker: 'Bonk Lab',
  },
];

export function cycleLandingShotIndex(index, delta, length) {
  return ((index + delta) % length + length) % length;
}

export function landingShotCoverRole(index, current, length) {
  if (index === current) {
    return 'current';
  }
  if (index === cycleLandingShotIndex(current, 1, length)) {
    return 'next';
  }
  if (index === cycleLandingShotIndex(current, -1, length)) {
    return 'previous';
  }
  return 'hidden';
}
